export default __webpack_public_path__ + "67e3db704f60cca5439ae9766d7c8379.png";